module.exports = __webpack_public_path__ + "img/66.1aede9e1.jpg";